import { useFieldContext } from '../FieldContext';
import { formatNumber } from '../format';
import { EmptyValue } from './EmptyValue';

export function NumberDisplay() {
  const { value } = useFieldContext();
  if (typeof value !== 'number') {
    return <EmptyValue />;
  }
  return <span className="block tabular-nums">{formatNumber(value)}</span>;
}
